import { render, staticRenderFns } from "./AscFeatureFlagsWrapper.vue?vue&type=template&id=07de2688&"
import script from "./AscFeatureFlagsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscFeatureFlagsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports